import React from "react";
import { notification } from "antd";
import { createEditTestSuite } from "../action";
import {
  notifyError,
  notifyInProgress,
  notifySuccess,
} from "../../../utils/notification";
import TestSuiteScriptSelectorModal, {
  OnSubmitParams,
} from "./TestSuiteScriptSelectorModal";

interface NewExecutionSuiteModalType {
  open: boolean;
  close: (open: boolean) => void;
  handleRefresh: () => Promise<any>;
}

const NewExecutionSuiteModal = ({
  open,
  close,
  handleRefresh,
}: NewExecutionSuiteModalType) => {
  const handleOnCreate = async ({
    accountId,
    suiteName,
    testcaseObjects,
    closeModal,
    refresh,
  }: OnSubmitParams) => {
    if (!suiteName?.trim()) {
      notifyError("Test suit name is required");
      return;
    }

    if (!testcaseObjects.length) {
      notifyError("At least one test case is required");
      return;
    }

    notifyInProgress("Creating test suite");
    const success = await createEditTestSuite({
      accountId,
      name: suiteName.trim(),
      testcases: testcaseObjects,
    });
    notification.destroy();

    if (!success) {
      notifyError("Failed to create test suite");
      return;
    }

    closeModal();
    await refresh();
    notifySuccess("Test suite created successfully");
  };

  return (
    <TestSuiteScriptSelectorModal
      open={open}
      close={close}
      handleRefresh={handleRefresh}
      title="Create new execution suite"
      submitButtonText="Create new"
      showSuiteNameField
      onSubmit={handleOnCreate}
    />
  );
};

export default NewExecutionSuiteModal;
